export const COLORS = {
  white: "#fff",
  black: "#000",
  primary: "#e4daf3",
  secondry: "#7747c3",
  error: "rgba(224, 32, 32, 0.2)",
  warning: "#de0036;",
  purple: "#7747c3",
  lightPurple: "#e4daf3",
  yellow: "#f8c129",
  red: "red",
};
